var map = {
	"./alert0_v2.svg": "4483",
	"./alert1.svg": "d57a",
	"./alert1_v2.svg": "ea22",
	"./alert2.svg": "c832",
	"./alert2_v2.svg": "498e",
	"./alert3.svg": "f904",
	"./alert3a_v2.svg": "669c",
	"./alert3b_v2.svg": "d4e1",
	"./alert4.svg": "5f61",
	"./alert4_v2.svg": "8f10",
	"./alertfill.svg": "3aa7",
	"./bed.svg": "073c",
	"./indicator0_gray_v2.svg": "3eb8",
	"./indicator0_v2.svg": "cc54",
	"./indicator1.svg": "fd60",
	"./indicator1_gray_v2.svg": "3971",
	"./indicator1_light.svg": "1807",
	"./indicator1_v2.svg": "bef3",
	"./indicator2.svg": "5bd4",
	"./indicator2_gray_v2.svg": "6f65",
	"./indicator2_light.svg": "3a9d",
	"./indicator2_v2.svg": "5b88",
	"./indicator3.svg": "6efc",
	"./indicator3_light.svg": "2ea2",
	"./indicator3a_gray_v2.svg": "80cf",
	"./indicator3a_v2.svg": "a265",
	"./indicator3b_gray_v2.svg": "8d71",
	"./indicator3b_v2.svg": "1bf3",
	"./indicator4.svg": "ec61",
	"./indicator4_gray_v2.svg": "7127",
	"./indicator4_light.svg": "d1c6",
	"./indicator4_v2.svg": "9546",
	"./japan.svg": "b3cd",
	"./logo.svg": "9b19",
	"./okinawa.svg": "9e1e",
	"./virus.svg": "aca5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f65";